import { experiment } from '@/experiments'

export function setExperimentUser (user) {
  if (user) {
    experiment.setUser({
      user_id: user
    })
    experiment.fetch()
  }
}
